export const isPresent = (x) => {
  // idea is the same as ruby's present? method
  // false if [], {}, '', null
  if (!x)
      return false;
  if (typeof (x) == typeof ('string') || x.constructor.name == "Array") {
      return x.length > 0;
  }
  if (x instanceof Date) {
      return !isNaN(x);
  }
  if (typeof (x) == typeof ({})) {
      return Object.keys(x).length > 0;
  }
  // shouldn't get reached probably?
  return true;
}

export const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;


// Function to recursively flatten object properties
export const flattenObject = (obj, parentKey = '') => {
  const flattened = {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const nestedKey = parentKey ? parentKey + '.' + key : key;

      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        const nestedObj = flattenObject(obj[key], nestedKey);
        Object.assign(flattened, nestedObj);
      } else {
        flattened[nestedKey] = obj[key];
      }
    }
  }

  return flattened;
}
